import React from 'react';

const Confirmation = ({ isOpen, message, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-700 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-md shadow-lg w-1/3">
                <p>{message}</p>
                <div className="mt-4 flex ">
                    <button
                        onClick={onConfirm}
                        className="bg-[#2A668D]  text-white px-4 py-2 rounded mr-2"
                    >
                        Yes
                    </button>
                    <button
                        onClick={onCancel}
                        className="bg-gray-400 text-white px-4 py-2 rounded"
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Confirmation;
